import { render, staticRenderFns } from "./ControlCenterView.vue?vue&type=template&id=98be3c24&"
import script from "./ControlCenterView.vue?vue&type=script&lang=js&"
export * from "./ControlCenterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports